import { render, staticRenderFns } from "./BrandModal.vue?vue&type=template&id=b2eaaece&scoped=true"
import script from "./BrandModal.vue?vue&type=script&lang=js"
export * from "./BrandModal.vue?vue&type=script&lang=js"
import style0 from "./BrandModal.vue?vue&type=style&index=0&id=b2eaaece&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2eaaece",
  null
  
)

export default component.exports